import getApiClient from "./../../../../shared/api";
import { showInfo, showError, showWarning, clearNotifications } from "./../../../../notifications/ducks/actions";

export const UPLOAD_ACTORS = "UPLOAD_ACTORS";
export const UPLOAD_ACTORS_CLEAR_ERRORS = "UPLOAD_ACTORS_CLEAR_ERRORS";

export function uploadActors(filmId, formData) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_ACTORS,
      payload: getApiClient().post(`film/${filmId}/Actor/Upload`, formData, {
        headers: {
          "content-type": `multipart/form-data`
        }
      })
    })
      .then((response) => {
        dispatch(showInfo(`Successfully uploaded actors`));
      })
      .catch((response) => {
        dispatch(showError(`Error uploading actors`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function clearErrors() {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_ACTORS_CLEAR_ERRORS,
    });
  };
}

